<template>
  <div
    v-if="$store.getters.currentProjectName"
    class="project-tabs df fdr jcsb"
    v-bind:class="{ 'project-tabs-extra': !$store.getters.emailVerified }"
  >
    <span class="df fdr tabs-wrap">
      <p
        class="one-tab nexa-font-bold"
        v-on:click="goTo('projectpricing', $route.params.projectid)"
        v-bind:class="{ 'current-tab': projectPage == 'pricing' }"
      >
        Pricing
      </p>
      <p
        class="one-tab nexa-font-bold"
        v-if="!$store.getters.tokenData.email"
        v-on:click="goTo('projecttasks', $route.params.projectid)"
        v-bind:class="{ 'current-tab': projectPage == 'tasks' }"
      >
        Tasks
      </p>
      <!-- <p  class="one-tab nexa-font-bold"
          v-if="!$store.getters.tokenData.email && ($store.getters.companyPlan.toLowerCase() !== 'free')"
          v-on:click="goTo('projectphases', $route.params.projectid)"
          v-bind:class="{'current-tab':  projectPage == 'phases'}">
        Phases
      </p> -->
      <p
        class="one-tab nexa-font-bold"
        v-on:click="goTo('projecttotals', $route.params.projectid)"
        v-bind:class="{ 'current-tab': projectPage == 'totals' }"
      >
        Totals
      </p>
    </span>
    <span v-if="projectPage == 'pricing'" class="df fdr aic">
      <p
        class="one-tab nexa-font-bold"
        v-if="editable"
        v-on:click="startShareProject()"
        v-bind:class="{ 'current-tab': projectPage == 'totals' }"
      >
        Share
      </p>
      <p
        class="one-tab nexa-font-bold"
        v-if="editable"
        v-on:click="exportPrices()"
        v-bind:class="{ 'current-tab': projectPage == 'totals' }"
      >
        Export
      </p>
      <p
        v-if="editable"
        class="one-tab nexa-font-bold tabs-divider"
      >
        |
      </p>
      <img
        v-if="editable"
        src="/images/Undo-Button.png"
        class="toggles v-step-3"
        alt=""
        @click="undo"
      />
      <img
        v-if="editable"
        src="/images/Redo-Button.png"
        class="toggles v-step-3"
        alt=""
        @click="redo"
      />
      <p
        v-if="editable"
        class="one-tab nexa-font-bold tabs-divider"
      >
        |
      </p>
      <img
        v-if="editable"
        src="/images/AddResource-default.png"
        class="toggles v-step-3"
        alt=""
        v-on:click="addNewResource()"
      />
      <img
        src="/images/Calculator-Button-2.png"
        v-if="$store.getters.showCalculator"
        class="toggles"
        alt=""
        v-on:click="toggleCalculator()"
      />
      <img
        src="/images/Calculator-Button.png"
        v-if="!$store.getters.showCalculator"
        class="toggles"
        alt=""
        v-on:click="toggleCalculator()"
      />

      <img
        src="/images/comments-on.svg"
        v-if="$store.getters.showPricesComments"
        class="toggles"
        alt=""
        v-on:click="toggleComments()"
      />
      <img
        src="/images/comments-off.svg"
        v-if="!$store.getters.showPricesComments"
        class="toggles"
        alt=""
        v-on:click="toggleComments()"
      />
      <!-- disable if hours == 0 -->
      <img
        src="/images/Hours-On.svg"
        v-if="$store.getters.showPricesHours && totalHoursSum() !== '0.0'"
        class="toggles"
        alt=""
        v-on:click="toggleHours()"
      />

      <img
        src="/images/Hours-Off.svg"
        v-if="!$store.getters.showPricesHours && totalHoursSum() !== '0.0'"
        class="toggles"
        alt=""
        v-on:click="toggleHours()"
      />

      <img
        src="/images/Hours-Off.svg"
        v-else-if="totalHoursSum() == '0.0'"
        class="toggles disabled-toggles hours-hover-toggle"
        alt=""
      />

      <span class="tooltip tooltip-no-hours">
        <span class="posrel">
          <!-- <img class="icon" src="/images/Help.svg" alt=""> -->
          <span class="box tooltip-box tooltip-top-right df fdc">
            <p class="tooltip-title">
              Your project only has fixed prices
            </p>
            <p class="tooltip-text">
              Because you don't have any people on your project, you haven't
              estimated any hours. Add at least one hourly resource to begin
              adding hours to your project.
            </p>
            <span class="tooltip-link">
              <p @click="addNewProject()">
                Create an hourly resource
              </p>
              <img
                class="icon"
                src="/images/Hours-Blue.svg"
                alt=""
              />
            </span>
            <span class="tooltip-link">
              <p @click="addPercentColumn()">
                Create a variable resource
              </p>
              <img
                class="icon"
                src="/images/Percentage-Blue.svg"
                alt=""
              />
            </span>
          </span>
        </span>
      </span>

      <img
        src="/images/Price-On.svg"
        v-if="$store.getters.showPricesPrices"
        class="toggles"
        alt=""
        v-on:click="togglePrices()"
      />
      <img
        src="/images/Price-Off.svg"
        v-if="!$store.getters.showPricesPrices"
        class="toggles"
        alt=""
        v-on:click="togglePrices()"
      />
    </span>
    <span
      v-if="projectPage == 'tasks' && !$store.getters.tokenData.email"
      v-on:click="addNewProject()"
      class="add"
    >
      +
    </span>
    <span
      v-if="projectPage == 'phases' && !$store.getters.tokenData.email"
      v-on:click="addNewPhase()"
      class="add"
    >
      +
    </span>
  </div>
</template>

<script>
import router from "../../router";
import { EventBus } from "../../event-bus";
import { mapGetters } from 'vuex';

const axios = require("axios");

import qs from "qs";

export default {
  name: "ProjectTabs",
  data() {
    return {
      selectedPriceRange: "mid"
    };
  },
  props: ["projectPage"],
  components: {},
  methods: {
    addNewResource() {
      console.log('add new resource')
      EventBus.$emit("addAndEditNewResource");
    },
    totalHoursSum() {
      var priceTotal = 0;
      for (
        var module = 0;
        module <
        (this.$store.getters.currentProjectModules
          ? this.$store.getters.currentProjectModules.length
          : 0);
        module = module + 1
      ) {
        priceTotal =
          parseFloat(priceTotal) + parseFloat(this.hoursSumModule(module));
      }
      // priceTotal = priceTotal + (priceTotal * this.$store.getters.currentProjectContingency/100)
      for (var override in this.$store.getters.currentProjectOverrides) {
        if (
          this.$store.getters.currentProjectOverrides[override].type ==
          "percent"
        ) {
          priceTotal =
            priceTotal +
            priceTotal *
              (this.$store.getters.currentProjectOverrides[override].value /
                100);
        } else {
          // priceTotal = priceTotal + parseFloat(this.$store.getters.currentProjectOverrides[override].value)
        }
        console.log(
          "OVERRIDE",
          this.$store.getters.currentProjectOverrides[override]
        );
      }
      return priceTotal.toFixed(1);
    },
    hoursSumModule(key) {
      var moduleSum = 0;
      for (var component in this.$store.getters.currentProjectModules[key]
        .components) {
        moduleSum =
          moduleSum + parseFloat(this.hoursSumComponent(key, component));
      }
      return moduleSum.toFixed(1);
    },
    hoursSumComponent(key, key2) {
      var componentTotal = 0;
      var rate = this.$store.getters.currentProjectRate;
      var contingency = this.$store.getters.currentProjectContingency;
      var overrides = this.$store.getters.currentProjectOverrides;

      var modules = this.$store.getters.currentProjectModules;
      var columns = this.$store.getters.currentProjectModuleColumns;
      var totalPercent = 0;

      var module = key;
      var component = key2;

      var quantity =
        modules[module].components[component].moduleColumns.metaElements[
          modules[module].components[component].moduleColumns.metaElements
            .length - 1
        ][this.selectedPriceRange];

      if (modules[module].components[component] && !modules[module].components[component].disabled) {
        for (var element in modules[module].components[component].moduleColumns
          .hourlyElements) {
          if (columns.hourlyElements[element] && !columns.hourlyElements[element].disabled) {
            var hours =
              modules[module].components[component].moduleColumns
                .hourlyElements[element][this.selectedPriceRange];
            componentTotal = componentTotal + quantity * hours;
          }
        }

        const startingTotal = componentTotal;

        for (var element in modules[module].components[component].moduleColumns
          .percentTasks) {
          if (columns.percentTasks[element] && !columns.percentTasks[element].disabled) {
            var percent =
              columns.percentTasks[element].taskPercentOverride || 0;
            if (
              modules[module].components[component].moduleColumns.percentTasks[
                element
              ][this.selectedPriceRange]
            ) {
              percent =
                modules[module].components[component].moduleColumns
                  .percentTasks[element][this.selectedPriceRange];
            }
            if (!this.loaded) {
              this.loaded = true;
            }
            var addToTotal = startingTotal * (percent / 100);
            componentTotal = componentTotal + addToTotal;
          }
        }
      }
      return componentTotal.toFixed(1);
    },
    startShareProject() {
      var data = {
        projectid: this.$route.params.projectid
      };
      this.$store.dispatch("startShareProject", data).then(() => {
        console.log("after startShareProject");
      });
      this.$store.dispatch("showGlobalPopup", { show: true }).then(() => {
        console.log("after showGlobalPopup");
      });
    },
    exportPrices() {
      this.$store.dispatch("popupExportProjectData", { show: true });
      this.$store.dispatch("showGlobalPopup", { show: true });
    },
    addNewProject() {
      var data = {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid
      };
      console.log("addHourlyColumn");
      this.$store.dispatch("addHourlyColumn", data).then(() => {
        console.log("after addHourlyColumn");
      });
    },
    addPercentColumn() {
      var data = {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid
      };
      console.log("addPercentColumn");
      this.$store.dispatch("addPercentColumn", data).then(() => {
        console.log("after addPercentColumn");
      });
    },
    addNewPhase() {
      var data = {
        projectid: this.$route.params.projectid
      };
      console.log("addNewPhase");
      this.$store.dispatch("addNewPhase", data).then(() => {
        console.log("after addNewPhase");
      });
    },
    activeTab() {
      var _tab = this.$route.fullPath;
      _tab = _tab.substr(1, _tab.length - 1);
      _tab = _tab.substr(0, _tab.indexOf("/"));
      return _tab;
    },
    goTo(path, id) {
      var _path = "/" + path;
      id ? (_path = _path + "/" + id) : null;
      router.push(_path);
    },
    toggleComments() {
      this.$store.dispatch("toggleComments", {})
    },
    toggleCalculator() {
      this.$store.dispatch("toggleCalculator", {})
    },
    toggleHours() {
      this.$store.dispatch("toggleHours", {})
    },
    togglePrices() {
      this.$store.dispatch("togglePrices", {})
    },
    undo() {
      this.$store.dispatch("undoAction", { projectid: this.$route.params.projectid })
    },
    redo() {
      this.$store.dispatch("redoAction", { projectid: this.$route.params.projectid })
    }
  },
  computed: {
    ...mapGetters(['userRole']),
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
.toggles {
  cursor: pointer;
  height: 25px;
  width: 25px;
  object-fit: contain;
  object-position: center;
  margin-right: 15px;
  margin-top: 10px;

  &:last-child {
    margin-right: 0;
  }
}

.disabled-toggles {
  opacity: 0.4;
}

//
// Project Tabs
//
.project-tabs {
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
  padding-left: 50px;
  padding-right: 50px;

  // span
  & > span {
    & > p {
      padding: 25px 0px 15px;
      text-transform: uppercase;
      color: #848484;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
      line-height: 14px;
      margin-right: 40px;
    }
    & > p.current-tab {
      color: #000;
    }
  }

  // Responsive Style
  // @media max-width: 1024px
  @media (max-width: 1024px) {
    top: 185px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;

    // aic
    > .aic {
      display: none;
    }
  }

  // Responsive Style
  // @media max-width: 520px
  @media (max-width: 520px) {
    top: 230px;
  }
}

.current-tab {
  border-bottom: 5px solid #dd5050;
}
.project-tabs-extra {
  top: 150px;
}
.add {
  z-index: 6;
  height: 60px;
  width: 60px;
  /*background-color: #0874D8;*/
  background-color: #5558ff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  right: 40px;
  transform: translateY(50%);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  color: white;
  font-size: 28px;
  font-weight: 500;
}
.one-tab {
  cursor: pointer;
}
.tabs-divider {
  font-size: 12px !important;
  color: #dfdfdf;
}

.tooltip-no-hours {
  width: 0;
  height: 0;
}

.tooltip-box {
  right: 26px;
}

.hours-hover-toggle:hover {
  & + .tooltip {
    & > span {
      & > .tooltip-box {
        display: unset;
      }
    }
  }
}

/*hours-hover-toggle" alt="" v-on:click="toggleHours()">

      <span class="tooltip tooltip-no-hours">
        <span class="posrel">
          <!-- <img class="icon" src="/images/Help.svg" alt=""> -->
          <span class="box tooltip-box tooltip-top-right df fdc">
            <p class="tooltip-title">
              Your project only has fixed prices
            </p>
            <p class="tooltip-text">*/
</style>
